module.exports = __webpack_public_path__ + "static/media/amber-shoes@3x.7d171a32.png";